<script>
	import "./MenuItem.scss";
	import MenuItemTitle from "./MenuItemTitle.svelte";
	
	let className = "";
  	export {className as class};
  	export let title = "";
	export let icon = null;
	export let materialIcon = null;
</script>

<div class={"menu-item border-shadow " + className} >
	<MenuItemTitle {...$$props}>
		<slot name='context-menu'></slot>
	</MenuItemTitle>
	<slot/>
</div>
